<template>
  <section>
    <base-header>
      <div class="row align-items-center  pt-header">
        <div class="col-lg-6 col-md-6 col-sm-6 col-7 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>

          <div>
            <h1 class="title-view">
              Coverage Area
            </h1>

            <div class="box-id">
              <h2 class="number-id">
                {{ areaCode }}
              </h2>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-5 text-right">
          <base-button type="primary" class="min-button" @click="saveArea()">
            <i class="flaticon-floppy-disk icon-no-margin"></i>
            <strong class="d-lg-block d-none">Save</strong>
          </base-button>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="card">
            <div class="row mb-2">
              <div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-12">
                <WSelect
                  v-bind:class="{
                    'is-invalid': $v.area.branch.$error
                  }"
                  placeholder="Select Destination"
                  v-model="area.branch"
                  filterable
                  id="name_branch"
                  disabled
                  name="name_branch"
                  label="Destination"
                  :error="$v.area.branch.$error ? `Select a Destination` : ''"
                  markrequired
                >
                  <el-option
                    v-for="branch in branchesOptionsByOperatorId"
                    :value="branch._id"
                    :label="branch.name"
                    :key="branch._id"
                  ></el-option>
                </WSelect>
              </div>

              <div
                class="col-xl-9 col-lg-9 col-md-8 col-sm-12 col-12 mb-2"
                v-bind:class="{ 'is-invalid': $v.area.description.$error }"
              >
                <el-input
                  v-model="$v.area.description.$model"
                  placeholder="Description"
                  id="description"
                  name="description"
                  tabindex="2"
                  maxlength="160"
                  type="textarea"
                  :autosize="{ minRows: 1, maxRows: 5 }"
                  show-word-limit
                  label="Description"
                  markrequired
                >
                </el-input>
                <div
                  v-if="$v.area.description.$error"
                  class="invalid-feedback mt--1"
                >
                  {{
                    !$v.area.description.minLength || $v.area.description.$error
                      ? `Enter ${$v.area.description.$params.minLength.min} to ${$v.area.description.$params.maxLength.max} characters.`
                      : ""
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="card pb-4">
            <base-input
              id="autocomplete"
              label="Search Location"
              placeholder="Enter Location"
              v-model="search"
              class="abso-map-1"
            />
            <el-tooltip placement="bottom" content="Reset Area">
              <base-button
                type="outline-neutral"
                class="min-button btn-line-danger abso-map-3"
                @click="clearCoordinates"
              >
                <i class="flaticon-eraser"></i> Reset Area
              </base-button>
            </el-tooltip>
            <google-map
              @restartCoordinates="resetCoordinatesInTheMap"
              :reset="resetCoordinates"
              @getFullCoordinates="saveCoordinates"
              :coord="coordinates"
            ></google-map>
          </div>
        </div>
      </div>

      <div class="alinmov2 mb-5">
        <el-tooltip content="Back" placement="bottom">
          <base-button
            type="neutral"
            class="btn-icon-only"
            @click="goToPreviousPage()"
          >
            <i class="flaticon-left-1"></i>
          </base-button>
        </el-tooltip>

        <base-button type="primary" class="min-button mb-0" @click="saveArea()">
          <i class="flaticon-floppy-disk"></i>Save
        </base-button>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapMutations } from "vuex";
import GoogleMap from "../../Components/GoogleMap";
import endpoint from "../../Commons/Services/index";
import localHelper from "../Commons/Helper";

import WSelect from "@/components/Select";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Checkbox,
  Switch,
  Card
} from "element-ui";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import lodash from "lodash";
import { goBack, unauthorizedAction } from "../../../helpers/commons.helpers";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "EditCoverageAreas",
  data() {
    return {
      branchesOptionsByOperatorId: [],
      area: {
        description: "",
        supplier: "",
        branch: "",
        polygon: [],
        relationship: {
          owner: null,
          type: "supplier"
        }
      },
      minimumSelect: [2, 4, 6, 8, 10],
      tempCoordinates: [],
      coordinates: [],
      resetCoordinates: false,
      search: null,
      loading: false,
      options: [],
      areaCopy: {},
      saved: false,
      areaId: "",
      supplierName: "",
      areaCode: "",
      branchName: ""
    };
  },
  watch: {},
  async created() {
    var bread = [
      {
        text: "Coverage Areas",
        to: "/coverage-areas"
      },
      {
        text: "Area Details",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.areaId = this.$route.params.id;
    await this.getOneArea(this.areaId);
    await this.getOperatorsSelections();
  },
  methods: {
    async getOneArea(areaId) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.areas.services.getAreaById(
          areaId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          let area = data.data;
          this.area.supplier = area.supplier._id;
          let branchs = await this.getBranchesOptions(
            area.supplier._id,
            area.branch._id
          );
          this.areaCode = area.code;
          this.area.description = area.description;
          this.area.polygon = this.parseCoordinates(area.polygon);
          this.coordinates = this.area.polygon;
          this.area.relationship.owner = area.relationship.owner;
          this.area.relationship.type = area.relationship.type;

          /**Clone service area*/
          this.areaCopy = lodash.cloneDeep(this.area);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async getBranchesOptions(supplierId, branchId) {
      try {
        let {
          data
        } = await endpoint.branches.services.getBranchesOptionsByOperatorId(
          supplierId,
          this.sesion.token
        );
        if (data.code === 200) {
          this.branchesOptionsByOperatorId = data.data;
          this.area.supplier = supplierId;
          this.area.branch = branchId;
        }
      } catch (error) {
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async saveArea(router = null) {
      if (!this.$v.area.$invalid) {
        await this.updateArea(this.areaId, this.area, router);
      } else {
        this.$v.area.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async updateArea(areaId, area, router) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.areas.services.updateAreaById(
          areaId,
          area,
          this.sesion.token
        );
        this.setLoad(false);
        this.saved = true;
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Coverage Area has been Updated",
            icon: "flaticon-check-3"
          });
          if (router) {
            this.$router.push(router);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "There was an error saving the Coverage Area, please try again"
        );
      }
    },
    resetCoordinatesInTheMap(status) {
      this.resetCoordinates = status;
    },
    saveCoordinates(coordinates) {
      this.tempCoordinates = coordinates;
      if (this.tempCoordinates.length > 0) {
        this.area.polygon = this.parseCoordinates(this.tempCoordinates);
      }
    },
    parseCoordinates(coordinates) {
      return coordinates.map(function(element) {
        return { lat: element.lat, lng: element.lng };
      });
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = unauthorizedAction(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    async clearCoordinates() {
      let { value } = await Swal.fire({
        title: "Reset marked area",
        text: "Are you sure do you want to reset the marked area ?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        this.resetCoordinates = true;
      }
    },
    async detectChanges(to, from, next) {
      if (!this.sigout) {
        let isEqual = lodash.isEqual(this.area, this.areaCopy);
        if (!isEqual && !this.saved) {
          let { value, dismiss } = await Swal.fire({
            title: "Important",
            html:
              "The Coverage Areas has been modified, <br> do you want to save changes?",
            imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
            buttonsStyling: false,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            reverseButtons: true,
            cancelButtonText: "No",

            confirmButtonText: "Yes",
            confirmButtonClass: "btn btn-primary btn-small-one"
          });
          if (value) {
            this.saveArea(to.path);
          } else if (dismiss === Swal.DismissReason.cancel) {
            next();
          }
        } else {
          next();
        }
      } else {
        next();
      }
    },
    ...mapActions(["getOperatorsSelections"]),
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setItemsBread",
      "setAreasSearchCriteria"
    ])
  },
  components: {
    [Checkbox.name]: Checkbox,
    [Switch.name]: Switch,
    [Card.name]: Card,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    "google-map": GoogleMap,
    WSelect
  },
  computed: {
    ...mapGetters([
      "operatorSelections",
      "sesion",
      "sigout",
      "ratesSearchCriteria"
    ])
  },
  validations: {
    area: {
      description: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(160)
      },
      supplier: {
        required
      },
      branch: {
        required
      },
      polygon: {
        $each: {
          lat: {},
          lng: {}
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    localHelper.isInAreasModule(
      to.meta.modules,
      this.setAreasSearchCriteria,
      "areas"
    );
    this.detectChanges(to, from, next);
  }
};
</script>
